module.exports = __webpack_public_path__ + "img/car_sendai22.2e8e0fc3.jpg";